import {
    SET_ALL_PERMISSIONS
} from '../actions/types';
const initialState = {};

export default (state = initialState, action) => {
	const payload = action.payload;
	switch (action.type) {
        case SET_ALL_PERMISSIONS: 
            return {
                ...state,
                ...payload
            };
        default:
            return state;
    }
}